import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login/login'
import person from '@/components/person/person'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/person',
      name: 'person',
      component: person
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js